import React from 'react';
import HeroView from '../view/DemoView';

const HeroSection: React.FC = () => {
  return <HeroView />;
};

export default HeroSection;